import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IApiResponse } from '../interfaces/api/api-response.interface';
import { ClientSideApiError } from '../interfaces/api/client-side-api-error.interface';
import { KendoNotificationService } from '../services/common/kendo-notification.service';
import { LoggerService } from '../services/common/logger.service';
import { RequestObserverService } from '../services/common/request-observer.service';
import { ServersideAlertService } from '../services/onboarding/serverside-alert.service';
import { handleHttpError } from './handle-http-error';

@Injectable()
export class ServersideAlertInterceptor implements HttpInterceptor {
  private apiUrl = environment.apiUrl;
  constructor(
    private kns: KendoNotificationService,
    private ssas: ServersideAlertService,
    private requestObserver: RequestObserverService,
    private logger: LoggerService,
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        next: (res: any) => {
          const apiResponse: IApiResponse = res?.body;
          if (
            apiResponse &&
            apiResponse['statusCode'] !== undefined &&
            apiResponse.statusCode.toString().charAt(0) === '4' &&
            apiResponse.errors !== null
          ) {
            this.requestObserver.reportError();
            const errorMessages: string[] = apiResponse.errors.map(
              (err: ClientSideApiError) => err.validationErrorMessage,
            );
            this.ssas.reportAlert(errorMessages, 'error');
          }
        },
        error: (error: HttpErrorResponse) => {
          this.requestObserver.reportError();
          handleHttpError(error, this.logger, this.kns);

          const apiResponse: IApiResponse = error?.error;
          if (
            apiResponse !== null &&
            apiResponse['statusCode'] !== undefined &&
            apiResponse.errors !== null
          ) {
            const errorMessages: string[] = apiResponse.errors.map(
              (err: ClientSideApiError) => err.validationErrorMessage,
            );

            this.ssas.reportAlert(errorMessages, 'error');
          } else {
            if (error.url?.toString().includes('OnBoarding/Login')) {
              window.location.href = this.apiUrl + 'OnBoarding/Login/Login';
            }
          }
        },
      }),
      finalize(() => {
        this.requestObserver.endRequest();
      }),
    );
  }
}
